import { render, staticRenderFns } from "./CreateClientAccess.vue?vue&type=template&id=96564bd2&"
import script from "./CreateClientAccess.vue?vue&type=script&lang=js&"
export * from "./CreateClientAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports